export default "<div class=\"row-fluid\">\n    <h1>Dashboard</h1>\n</div>\n"